module.exports = __webpack_public_path__ + "img/20220415_101229.e9bf5087.jpg";